// aurora.jsx - breathing soft aurora gradient for hero backgrounds.
// Pure CSS. Two large blurred orbs drifting on long offset sine paths.

function Aurora({ palette }) {
  const p = palette || { a: '#3b82f6', b: '#60a5fa', c: '#1e40af' };
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
      <div className="aurora-a" />
      <div className="aurora-b" />
      <div className="aurora-c" />
      <div className="aurora-grain" />
      <style>{`
        .aurora-a, .aurora-b, .aurora-c {
          position: absolute; border-radius: 50%;
          filter: blur(120px); opacity: 0.6;
          mix-blend-mode: screen;
          will-change: transform, opacity;
        }
        html.light .aurora-a, html.light .aurora-b, html.light .aurora-c {
          mix-blend-mode: normal !important;
          opacity: 0.16 !important;
        }
        .aurora-a {
          width: 900px; height: 900px;
          left: -20%; top: -30%;
          background: radial-gradient(circle, ${p.a} 0%, transparent 65%);
          animation: auroraA 22s ease-in-out infinite;
        }
        .aurora-b {
          width: 800px; height: 800px;
          right: -15%; top: 10%;
          background: radial-gradient(circle, ${p.b} 0%, transparent 65%);
          animation: auroraB 26s ease-in-out infinite;
          opacity: 0.45;
        }
        .aurora-c {
          width: 700px; height: 700px;
          left: 40%; bottom: -40%;
          background: radial-gradient(circle, ${p.c} 0%, transparent 65%);
          animation: auroraC 30s ease-in-out infinite;
          opacity: 0.55;
        }
        .aurora-grain {
          position: absolute; inset: 0;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3CfeColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.4'/%3E%3C/svg%3E");
          opacity: 0.03; mix-blend-mode: overlay;
        }
        html.light .aurora-grain {
          opacity: 0.015;
          mix-blend-mode: multiply;
        }
        @keyframes auroraA {
          0%,100% { transform: translate(0,0) scale(1); }
          50%     { transform: translate(120px, 80px) scale(1.08); }
        }
        @keyframes auroraB {
          0%,100% { transform: translate(0,0) scale(1.05); }
          50%     { transform: translate(-100px, 120px) scale(0.95); }
        }
        @keyframes auroraC {
          0%,100% { transform: translate(0,0) scale(1); }
          50%     { transform: translate(60px, -100px) scale(1.1); }
        }
        @media (max-width: 900px) {
          .aurora-a, .aurora-b, .aurora-c {
            width: 100vw !important;
            height: 100vw !important;
            max-width: 420px !important;
            max-height: 420px !important;
            filter: blur(80px) !important;
          }
          .aurora-b { right: 0 !important; }
          .aurora-a { left: -10% !important; }
        }
      `}</style>
    </div>
  );
}

window.Aurora = Aurora;
